module.exports = __webpack_public_path__ + "img/half_title.d5f6eb01.png";